var _circle, _circle2, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1719,
    cy: 18,
    r: 18,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1719,
    cy: 18,
    r: 17.5,
    stroke: "#9C4900",
    strokeOpacity: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_828_737",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.67188,
    y: 4.5,
    width: 27,
    height: 27,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_828_737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1719 24.1875C19.5781 24.1875 20.7736 23.6955 21.7584 22.7115C22.7424 21.7267 23.2344 20.5312 23.2344 19.125C23.2344 17.7188 22.7424 16.5233 21.7584 15.5385C20.7736 14.5545 19.5781 14.0625 18.1719 14.0625C16.7656 14.0625 15.5701 14.5545 14.5854 15.5385C13.6014 16.5233 13.1094 17.7188 13.1094 19.125C13.1094 20.5312 13.6014 21.7267 14.5854 22.7115C15.5701 23.6955 16.7656 24.1875 18.1719 24.1875ZM9.17188 28.125C8.55313 28.125 8.02363 27.9049 7.58338 27.4646C7.14238 27.0236 6.92188 26.4937 6.92188 25.875V12.375C6.92188 11.7562 7.14238 11.2267 7.58338 10.7865C8.02363 10.3455 8.55313 10.125 9.17188 10.125H12.7156L14.7969 7.875H21.5469L23.6281 10.125H27.1719C27.7906 10.125 28.3205 10.3455 28.7615 10.7865C29.2017 11.2267 29.4219 11.7562 29.4219 12.375V25.875C29.4219 26.4937 29.2017 27.0236 28.7615 27.4646C28.3205 27.9049 27.7906 28.125 27.1719 28.125H9.17188Z",
    fill: "#9C4900",
    fillOpacity: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCamera);
export default __webpack_public_path__ + "static/media/ic-camera.fd06f40f3be1045d415a07f57d4a0c63.svg";
export { ForwardRef as ReactComponent };